module.exports = __webpack_public_path__ + "img/cnc-04-kerawang.1703546b.png";